import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "video-list-shell"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ListItem = _resolveComponent("ListItem");
  const _component_GridItem = _resolveComponent("GridItem");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_row, {
    class: "video-list-row"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.videoObject.results, video => {
      return _openBlock(), _createBlock(_component_b_col, {
        cols: "12",
        sm: $options.getCols('sm'),
        md: $options.getCols('md'),
        lg: $options.getCols('lg'),
        key: video.id,
        class: "video-list-col"
      }, {
        default: _withCtx(() => [$props.displayType === 'list' ? (_openBlock(), _createBlock(_component_ListItem, {
          key: 0,
          video: video,
          preview: $props.preview,
          onPlay: $event => _ctx.$emit('play', video.id),
          onUpdateVideoFavoriteStatus: _cache[0] || (_cache[0] = $event => _ctx.$emit('update-video-favorite-status', $event))
        }, null, 8, ["video", "preview", "onPlay"])) : (_openBlock(), _createBlock(_component_GridItem, {
          key: 1,
          video: video,
          preview: $props.preview,
          onPlay: $event => _ctx.$emit('play', video.id),
          onUpdateVideoFavoriteStatus: _cache[1] || (_cache[1] = $event => _ctx.$emit('update-video-favorite-status', $event))
        }, null, 8, ["video", "preview", "onPlay"]))], undefined, true),
        _: 2
      }, 1032, ["sm", "md", "lg"]);
    }), 128))], undefined, true),
    _: 1
  })]);
}